module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTProBdCn.d02850ad.otf";